import { render } from "./ProcessBpmRulesAck.vue?vue&type=template&id=871a02b8&scoped=true"
import script from "./ProcessBpmRulesAck.vue?vue&type=script&lang=js"
export * from "./ProcessBpmRulesAck.vue?vue&type=script&lang=js"

import "./ProcessBpmRulesAck.vue?vue&type=style&index=0&id=871a02b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871a02b8"]])

export default __exports__